import Column from '@components/column'
import Row from '@components/row'
import { Constant } from '@utils/index'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {
  AuthorName,
  BookCategory,
  BookDetails,
  BookImage,
  BookListing,
  BookName,
  CoverImage,
  IndividualBook,
  ShowAllButton,
  Title,
  NoBooks,
  StyleAllBooks,
} from '../style'
import { useGenreBooks } from './genreContext'
import BookLoader from '../loader/bookLoading'
import { StyleFlexColumnCenter } from '@components/styles'
import SvgImage from '@components/svg'
import Button from '@components/button'
import { useNavigate } from 'react-router-dom'

const GenreBooks = () => {
  const { data: user } = useSelector((state: any) => state.user)
  const navigate = useNavigate()
  const ScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }
  const {
    genreBooks,
    loading,
    fetchBooksForGenres,
    loadMoreBooks,
    items,
    currentPages,
    isLoadMore,
    totalPages,
  } = useGenreBooks()

  const [showAllGenres, setShowAllGenres] = useState<Record<string, boolean>>(
    {},
  )

  const { data: booksCategories, loading: categoriesLoading } = useSelector(
    (state: any) => state.bookCategories,
  )

  const [availableGenre, setAvailableGenre] = useState<any[]>([])

  useEffect(() => {
    if (!categoriesLoading && booksCategories.length && !items.length) {
      const filteredGenres = booksCategories.filter(
        (item) => item.totalBooks > 6,
      )
      setAvailableGenre(filteredGenres)

      if (filteredGenres.length) {
        fetchBooksForGenres(filteredGenres)
      }
    }
  }, [categoriesLoading, booksCategories, items.length])
  const handleClick = (book) => {
    if (!!user?.id) {
      navigate(`/books/${book.name}/${book.id}`)
      ScrollToTop()
    } else {
      navigate(`/${book.name}/${book.id}`)
      ScrollToTop()
    }
  }
  const toggleShowAll = (genreName: string) => {
    setShowAllGenres((prev) => ({
      ...prev,
      [genreName]: !prev[genreName],
    }))
  }
  return (
    <>
      {Object.entries(genreBooks).map(([categoryName, books]) => {
        const category = availableGenre.find((c) => c.name === categoryName)
        return (
          <Column
            key={categoryName}
            styleColumn={
              'margin: 24px 0;@media (max-width: 1024px) { margin: 16px 0; }'
            }
          >
            <Column rowGap={24}>
              <Row justifyContent="space-between" alignItems="center">
                <Column>
                  <Title>
                    {showAllGenres[categoryName]
                      ? `All ${category?.name} Books`
                      : `Latest ${category?.name} Books`}
                  </Title>
                </Column>

                <ShowAllButton
                  style={{ marginTop: '8px' }}
                  onClick={() => toggleShowAll(category?.name)}
                >
                  {showAllGenres[categoryName] ? 'View Less' : 'Show All'}
                </ShowAllButton>
              </Row>
              {!showAllGenres[categoryName] ? (
                <BookListing>
                  {loading ? (
                    <>
                      {Array(10)
                        .fill(0)
                        .map((_, index) => (
                          <BookLoader key={index.toString()} />
                        ))}
                    </>
                  ) : !!books.length ? (
                    books.map((book: any) => (
                      <IndividualBook
                        key={book.id}
                        onClick={() => {
                          handleClick(book)
                        }}
                      >
                        <CoverImage>
                          <BookImage
                            src={
                              book?.coverImage
                                ? `${process.env.BUCKET_URL}/${book.coverImage}`
                                : Constant.defaultNoImage
                            }
                            alt={book.name}
                          />
                        </CoverImage>
                        <BookDetails>
                          <BookName>{book.name}</BookName>
                          <AuthorName>{book.author}</AuthorName>
                          <BookCategory>
                            {book?.categoryData?.name || 'Unknown Category'}
                          </BookCategory>
                        </BookDetails>
                      </IndividualBook>
                    ))
                  ) : (
                    <NoBooks>
                      <StyleFlexColumnCenter>
                        <SvgImage src="noBooksIcon" />
                        <span>No Books Available</span>
                      </StyleFlexColumnCenter>
                    </NoBooks>
                  )}
                </BookListing>
              ) : (
                <>
                  <StyleAllBooks>
                    {!!loading ? (
                      <>
                        {Array(10)
                          .fill(0)
                          .map((_, index) => (
                            <BookLoader key={index.toString()} />
                          ))}
                      </>
                    ) : !!books.length ? (
                      <>
                        {books.map((book: any) => (
                          <IndividualBook
                            key={book.id}
                            onClick={() => {
                              handleClick(book)
                            }}
                          >
                            <CoverImage>
                              <BookImage
                                src={
                                  book?.coverImage
                                    ? `${process.env.BUCKET_URL}/${book.coverImage}`
                                    : Constant.defaultNoImage
                                }
                                alt={book.name}
                              />
                            </CoverImage>
                            <BookDetails>
                              <BookName>{book.name}</BookName>
                              <AuthorName>{book.author}</AuthorName>
                              <BookCategory>
                                {book?.categoryData?.name || 'Unknown Category'}
                              </BookCategory>
                            </BookDetails>
                          </IndividualBook>
                        ))}
                        {!!isLoadMore[categoryName] && (
                          <>
                            {Array(2)
                              .fill(0)
                              .map((_, index) => (
                                <BookLoader key={index.toString()} />
                              ))}
                          </>
                        )}
                      </>
                    ) : (
                      <NoBooks>
                        <StyleFlexColumnCenter>
                          <SvgImage src="noBooksIcon" />
                          <span>No Books Available</span>
                        </StyleFlexColumnCenter>
                      </NoBooks>
                    )}
                  </StyleAllBooks>
                  {currentPages[categoryName] < totalPages[categoryName] && (
                    <Button
                      title="Load More..."
                      type="button"
                      styleButton="width: fit-content; margin: 16px auto;"
                      onClick={() => loadMoreBooks(categoryName)}
                    />
                  )}
                </>
              )}
            </Column>
          </Column>
        )
      })}
    </>
  )
}

export default GenreBooks
